import script from "./navbar-theme-switcher.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar-theme-switcher.vue?vue&type=script&setup=true&lang=js"

import "./navbar-theme-switcher.vue?vue&type=style&index=0&id=18acb5a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18acb5a4"]])

export default __exports__